import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Collapse, TableCell, TableRow } from '@mui/material';

import { reverseFormatDate } from '../../../utils/dateFunctions';

import AllActiveCourseDetails from './AllActiveCourseDetails';

import classes from '../../../commonStyles/tables.module.css';

const dropDownStyles = {
    paddingBottom: 0,
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    borderTop: 'none',
    borderBottom: 'none'
};

const AllCourseTableRow = ({ row, isDisabled, toggleDropdown, openId }) => {
    const [open, setOpen] = useState(null);

    const onToggleDropdown = () => {
        toggleDropdown(row.id);
        setOpen(open === row.id ? null : row.id);
    };

    useEffect(() => {
        if (openId !== row.id) setOpen(null);
    }, [openId]);

    return (
        <>
            <TableRow
                hover
                className={`${classes.tableRowStripes} ${classes.canOpen}`}
                onClick={onToggleDropdown}>
                <TableCell>{row.code}</TableCell>
                <TableCell>{row.name}</TableCell>
                <TableCell>{reverseFormatDate(row.startDate)}</TableCell>
                <TableCell>{reverseFormatDate(row.endDate)}</TableCell>
                <TableCell>{row.modules?.length || 'Ext'}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={dropDownStyles} colSpan={5}>
                    <Collapse in={open === row.id} timeout="auto" unmountOnExit>
                        <AllActiveCourseDetails row={row} isDisabled={isDisabled} onClose={() => setOpen(null)} />
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

AllCourseTableRow.propTypes = {
    row: PropTypes.object,
    isDisabled: PropTypes.bool,
    openId: PropTypes.string,
    toggleDropdown: PropTypes.func
};

export default AllCourseTableRow;
